<script>
import Swal from 'sweetalert2';

let notIphone = false;

async function handleDeliveryOptionChange(event) {
	//we're not changing the display until they answer about the iPhone which only has an e-SIM.
	const newOption = event.target.value;
	//const oldOption = $form_order.SIM_Delivery;

	if(newOption=='' || newOption == 'e-sim' || notIphone) { //if they already said it's not an iPhone don't ask again
		//$form_order.SIM_Delivery = newOption;
		return; 
		}

	const result = await Swal.fire({
		title: 'iPhone Compatibility Warning',
		html: `<div style="text-align: left;">
				Please keep in mind that if you are planning to use an iPhone 14 or 15, you must order an E-SIM, since they do not accept physical SIM cards.
			</div>
		`,
		icon: 'warning',
		//showCancelButton: true,
		confirmButtonText: 'I am not planning to use an iPhone 14 or 15: proceed to ordering a physical SIM card.',
		//cancelButtonText: 'Cancel',
		denyButtonText: 'I plan to use an iPhone 14 or 15: switch to order an E-SIM.',
		showCloseButton: false,
		allowEscapeKey: false,
		allowOutsideClick: false,
		reverseButtons: true,
		showDenyButton: true
		});

	if (result.isDenied) {
		$form_order.SIM_Delivery = 'e-sim';
		}
	else if (result.isConfirmed) {
		$form_order.SIM_Delivery = newOption;
		notIphone = true; // Cache the result that it's not an iPhone 14 or 15
		}
	//else {
		// If cancelled or closed, revert to the old option
		//event.target.value = oldOption;
		//} 
	}
const simPrice = 49;
const conversionRate = 3.6;
import { slide } from 'svelte/transition';

import Fa from 'svelte-fa'
import { faExclamationCircle, faAngleDoubleRight, faAngleDoubleLeft, faHome, faShoppingCart} from '@fortawesome/free-solid-svg-icons'

const simPriceUSD = (simPrice/conversionRate).toLocaleString('en-US', { style: 'currency', currency: 'USD' });


import feathers from '@feathersjs/feathers';
const app = feathers();

import rest from '@feathersjs/rest-client';
const restClient = rest() //configure with connection URL base
app.configure(restClient.fetch(window.fetch));
const sim_orders = app.service('sim_orders');
//const resellersList = app.service('resellers');
const pickup_locations = app.service('pickup_locations');
const tokenTranzila = app.service('token-tranzila');

import Spinner from 'svelte-spinner';
var loading=false;

function getCookie(cname) {//https://www.w3schools.com/js/js_cookies.asp
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
var refer = getCookie('refer') || null;

import { writable, get } from 'svelte/store'; //via https://github.com/higsch/higsch.me/blob/master/content/post/2019-06-21-svelte-local-storage.md
const createWritableStore = (key, startValue) => {
  const { subscribe, set } = writable(startValue);
	return {
    subscribe,
    set,
    useLocalStorage: () => {
      const json = localStorage.getItem(key);
      if (json) {
        set(JSON.parse(json));
      }
      
      subscribe(current => {
        localStorage.setItem(key, JSON.stringify(current));
      });
    }
  };
}
const form_order = createWritableStore('form_order', {});
form_order.useLocalStorage();

$: isESIM = $form_order.SIM_Delivery == 'e-sim';
$: isKosher = $form_order.SIM_Card_Needed_Count && $form_order.SIM_Card_Needed_Count.includes('kosher');

if (refer&&refer.toLowerCase()=='levaharon'){
	if(!$form_order.SIM_Delivery) $form_order.SIM_Delivery="rabbi-shoub";
	}


/*date picker box and work-arounds */
import Datepicker from 'svelte-calendar/src/Components/Datepicker.svelte';
import { formatDate } from 'timeUtils';
function formatDateISO(date){//if we didn't already depend on datepicker, then maybe just use the function from https://stackoverflow.com/a/23593099/1278519
	return formatDate(date,"#{Y}-#{m}-#{d}");//YYYY-MM-DD
	}

let dateChosen=false; //boolean if chosen -- because we default to today, so need to check if actually chosen
let selected;//unformatted initial choice
let formattedSelected;//formatted date for display

//Bunch of work-around to store the date as a normal YYYY-MM-DD string and restore it as such on load
if($form_order.Need_SIM_Date) {//re-initialize the datepicker as already having been chosen
	const savedDate=new Date($form_order.Need_SIM_Date);//json stringified, need to convert back to data object
	//console.log(new Date(formatDate(new Date())));
	if(savedDate>=new Date(formatDate(new Date()))) {//silently discard the the saved date if it's from the past
		dateChosen=true;//initialize that we already have a choice
		selected = savedDate;
		}
	}
$: $form_order.Need_SIM_Date = dateChosen ? formatDateISO(selected) : '';//save selected value into the form data - but only when chosen, and formatted as YYYY-MM-DD so we don't have ISO and tz messing things up.



var step=1;
var restrictToPayment=false;
//if we have a query string, then fetch the order ID
const urlParams = new URLSearchParams(window.location.search);
const order_id_query = urlParams.get('order_id');
if(order_id_query) {
	loading=true;
	step='loading';
	console.log('got a query id',order_id_query);
	sim_orders.get(order_id_query).then(function(data){
		loading=false;
		console.log(data);
		if(data.paid) {
			step=4;
			var errors=['Already paid!'];
			return;
			}
		if(data.delivered) {
			step=3;//already delivered, don't allow edits
			restrictToPayment=true;
			}
		else step=1; //need to return to the normal start
		$form_order=data;
		})
	.catch(function(err){
		console.log(err);
		errors=['Sorry, ' + err.message];
		loading=false;
		step='error loading';
		})
	}
//But we don't want them to save updates to the form if they already paid or it was shipped!


const pageTitles={
	 1: '1-enter-data'
	,2: '2-unlock-warning'
	,3: '3-pay'
	,4: '4-success'
	}
$: recordPage(pageTitles[step]);
function recordPage(url){
	if(!url) return;
	if(typeof hj!==undefined) hj && hj('stateChange', 'sim-order.html#/'+url);
	if(typeof gtag!==undefined) gtag && gtag('config', 'UA-168570359-1', { 'page_path': 'sim-order.html#/'+url});
	}

//import { Form, Field, ErrorMessage } from "svelte-forms-lib";
//import { Form, Input, Select, Choice } from 'sveltejs-forms';

//Step 1: main order form.

var errors=[];
//var order_id;//generated upon submission. Don't save it in `form`, since we're not PATCH'ing, we're POST'ing. @TODO: do an update instead?

$: price = updatePrice($form_order.SIM_Card_Needed_Count,$form_order.SIM_Delivery);//trigger an update when either of these changes.

function updatePrice(SIM_Card_Needed_Count,SIM_Delivery){
	if(!SIM_Card_Needed_Count) return 0;
	var price = 0;
	if(SIM_Card_Needed_Count=="1-sim&1-kosher") price = 49*2;
	else price = 49 * SIM_Card_Needed_Count[0];//first character is the count
	
	if(SIM_Delivery=='deliver-jerusalem') price+=30;//don't show this 30 shekel until they've chose a sim count
	return price;
	}

import Mailcheck from 'mailcheck/src/mailcheck';
var emailSuggestion;
function checkEmailAddress(){
	Mailcheck.run({email: $form_order.email,
		suggested: function(suggestion) {
			emailSuggestion=suggestion;
			}
		, empty: function(suggestion) {
			emailSuggestion=null;
			}
		});
	}
function setEmail(){
	$form_order.email = emailSuggestion.full;
	emailSuggestion=null;
	}

var pickup_locations_list = {
	USA: [
		{ id:11,name: '5-Towns (Woodmere)', group:'USA'}
		,{id:14,name: 'Baltimore', group:'USA'}
		,{id: 1,name: 'Brooklyn (Flatbush)', group: 'USA'}
		,{id: 6,name: 'Hollywood, FL', group:'USA'}
		,{id: 3,name: 'Lakewood (11th St)', group:'USA'}
		,{id: 5,name: 'Los Angeles (Hancock Park)', group:'USA'}
		,{id: 2,name: 'Monsey (Wesley Hills)', group:'USA'}
		,{id:12,name: 'Passaic, NJ', group:'USA'}
		,{id: 4,name: 'Teaneck (Bergenfield)', group:'USA'}
		,{id: 7,name: 'Yossi Taubenfeld', group:'USA'}
		]
	,Israel: [
		 {id: 9, name: 'Jerusalem (Center of Town)', group: 'Israel'}
		,{id: 8,name: 'Jerusalem (Maalot Dafna)', group: 'Israel'}
		,{id:10,name: 'Ramat Beit Shemesh A', group: 'Israel'}
		]
	};

pickup_locations.find({query:{enabled:1, $sort: {group:-1, name: 1}, $select: ["id","name","group"]}}).then(function(result){
	pickup_locations_list = result.reduce((groups, item) => {
		const group = (groups[item.group] || []);
		group.push(item);
		groups[item.group] = group;
		return groups;
		}, {});
	});


/*var resellers=[
	'Social Media'
	,'Aaron, Jonathan'
	,'Berger, Steve'
	,'Bogopulsky, Dovid - LiveYourBIL'
	,'Dauer, Asher'
	,'Dauer, Jacob'
	,'Ellenbogen, Dani'
	,'Greenes, Eli'
	,'Kaufman, Avi'
	,'Khalili, Moshe'
	,'Levy, Orel'
	,'Levy, Rachamim'
	,'Samet, Nati'
	,'Samet, Yehudit'
	//,'Sklar, Yonatan'
	//,'Telsner, Mordechai'
	//,'Weinberg, Avromi'
	//,'Zern, Avi'
	];
resellersList.find({query:{$sort: {name: 1}, $select: ["name"]}}).then(function(result){
	var list=['Social Media'];
	result.forEach(obj => list.push(obj.name));
	resellers=list;//trigger svelte to reload the arrary, and don't trigger until we've finished.
	});*/


async function submitPage1(event){
	errors=[];//reset at start
	console.log($form_order);
	
	if(event.altKey) {//TEST for avi: fill out data to let us move on. Test we didn't lose our data, too.
		$form_order= {
			email: 'natisamet@gmail.com'
			,SIM_Card_Needed_Count:'2'
			,SIM_Delivery: 'mail-us'
			,Mailing_Address:'Nati Samet, USA.'
			,Need_SIM_Date: new Date().toISOString().split("T")[0]
			,Customer_Name: 'Nati Samet'
			,Contact_Number: '00000000000'
			}
		dateChosen = true;
		}

	var schemaPageOne={ //yup.object().shape({ // initialize the Yup form later so we can play with the address/hotel requirements
		SIM_Delivery:		yup.string().required().trim()
			//need to check sub-fields are filled out
		,SIM_Card_Needed_Count:	yup.mixed().required().oneOf(["1","2","3","1-kosher","2-kosher","1-sim&1-kosher"])//as const ??
		,Need_SIM_Date: 	yup.date().required().min(new Date().toISOString().split("T")[0],'Need SIM Date must be today or later').typeError('Need SIM Date must be filled out') //simply using new Date() doesn't allow today, due to hours/minutes
		,Customer_Name:		yup.string().required().trim()
		,Contact_Number:	yup.string().required().min(10)
		,email:				yup.string().trim().required().email()
		//,referred_by: 		yup.string()
		,comments:			yup.string().trim()
		/*,Mailing_Address: 	yup.string().when('SIM_Delivery', function(deliver, schema){ //this was supposed to work!!!
				console.log(deliver);
				if(deliver.includes('mail')) schema.min(10).required();
				console.log(schema)
				return schema;
				})*/
		};//);

		schemaPageOne.Mailing_Address = $form_order.SIM_Delivery.includes('mail')			? yup.string().required().min(10) : yup.string();
		schemaPageOne.Hotel_Address_or_Name = $form_order.SIM_Delivery=='deliver-jerusalem'? yup.string().required().min(10) : yup.string();
		schemaPageOne.SIM_Pickup_Location = $form_order.SIM_Delivery=='pickup'				? yup.string().required() 		  : yup.string();
		
		console.log(schemaPageOne);

	await yup.object().shape(schemaPageOne).validate($form_order, {abortEarly:false})
		.catch(function(err){
			console.log(err);
			errors = err.errors.map(function(message){
				//SIM_Card_Needed_Count must be one of the following values: 1, 2, 1-kosher, 2-kosher, 1-sim&1-kosher
				//make it more user friendly, "SIM Card Needed Count"
				message = message.split(' ');
				message[0] = message[0].replace(/_/g,' ');
				message = message.join(' ');
				return message;
				});
			})
		
	if(!dateChosen) errors = [...errors, 'You must specify when you need the sim card(s)'];

	if(isESIM && isKosher) errors = [...errors, 'e-sims are not available for kosher lines'];

	if(errors.length) return;

	errors = [];

	loading=true;
	var result;
	if($form_order.id) result = await sim_orders.patch($form_order.id, {...$form_order, price})
		.catch(function(err){
			console.error(err.message);
			errors=[err.message];
			});
	else result = await sim_orders.create({...$form_order, price, referred_by: refer})//also submit the price @TODO: should recalc the price server side
		.catch(function(err){
			console.error(err.message);
			errors=[err.message];
			});
	loading=false;
	if(errors.length) return;

	$form_order.id=result.id;
	step=2;
	var elmnt = document.getElementById("page_title");
	elmnt.scrollIntoView();
	}


//Step 2: Unlock warning
async function submitPage2(event){
	if(!$form_order.unlock_warning) return errors=["You must read the instructions and specify what type of phone you have."];
	errors=[];
	step=3;
	var elmnt = document.getElementById("page_title");
	elmnt.scrollIntoView();
	}

let ask_security_code=false;//if we get a tranzila 006 error then try asking for the security code
//Step 3: Putting in CC details
import CreditCardForm from '../creditCardEntry.svelte';

var credit_card_valid;
var credit_card={};
import CreateSumitToken from '../web_create_token_sumit.js';

async function submitPayment(){
	if(!$form_order.id)  return errors=['Something is wrong, you aren\'t editing an active order. Please start over.'];
	if(!credit_card_valid) return errors=['Please enter valid payment information.'];
	errors=[];

	loading=true;

	var TranzilaTK = tokenTranzila.create({
			credit_card_number:credit_card.credit_card_number
			})
		.catch(function(err){
			console.error(err.message);
			errors=[...errors, err.message];
			});
	var sumitToken = CreateSumitToken(credit_card)
		.catch(console.error);
		
	[TranzilaTK, sumitToken] = await Promise.all([TranzilaTK,sumitToken]);

	if(errors.length) return loading=false;

	let cc_expiry=	'' + credit_card.expiry_month + credit_card.expiry_year //MMYY for tranzila
	let security_code = credit_card.security_code;
	const result = await sim_orders.patch($form_order.id, {TranzilaTK, sumitToken, cc_expiry, security_code, unlock_warning:$form_order.unlock_warning})//also submit the price @TODO: should recalc the price server side
		.catch(function(err){
			console.error(err.message);
			if(err.message.includes('Tranzila')) {
				if(err.message.includes('006')){
					ask_security_code=true;
					errors=['Credit card charge failed, please try adding the security code'];
					}
				else errors=['Credit card charge failed'];
				}
			else errors=[err.message];
			});
	loading=false;
	if(errors.length) return;

	console.log(result);
	if(result.paid) {
		//order_id=result.id;
		step=4;
		var elmnt = document.getElementById("page_title");
		elmnt.scrollIntoView();
		$form_order={};//reset the form, it's paid and done.
		}
	else errors=['Your payment mysteriously failed.'];
	}



</script>

<main>
{#if process.env.NODE_ENV=='test'}
	<div class="ribbon">
		<a href="#">Test site!</a>
	</div>
	{/if}

<h2 class="title-1 ff-dunbar fw-800 text-brand" id="page_title">SIM Card Order Form</h2>

<br />


{#if step=="loading"}

{#if loading} Loading... <Spinner /> {/if}



{:else if step=='error loading'}
<div transition:slide class="clearfix">

{#if errors && errors.length}
	<br />
	<div class="alert alert-danger">
	{#each errors as error}
		<div transition:slide>{error}</div>
	{/each}
	</div>
{/if}


<center>
		<a href="index.html" class="btn btn-success" ><Fa fw icon={faHome}/> Home</a>
		&nbsp;&nbsp;&nbsp;
		<a href="sim-order.html" class="btn btn-success btn-lg">Start New Order </a>
</center>

</div>

{:else if step=="1"}
<div transition:slide class="clearfix">
<ul class="ff-stag fw-400 text-black ml-4">
<li>SIM Cards cost a one-time {simPrice} Shekels each (approx {simPriceUSD})</li>
<li>SIM cards can be kept for all future activations.</li>
<li>SIM cards are triple-cut with all 3 sizes included (nano, micro, standard), so there is no need to specify which phone model you have.</li>
<li>SIM cards do not come with any monthly plan. You can only activate a plan after receiving your SIM card.</li>
</ul>
<br />

{#if refer}
	<span class="ff-dunbar title-2 text-brand">Referred by:</span> <span class="ff-dunbar text-brand" style="font-size: 18px;">{refer}</span>
	<br><br>
{/if}

	<label class="ff-dunbar title-2 text-brand" for="SIM_Delivery">How would you like to receive your SIM card(s)? *</label>
	<select bind:value={$form_order.SIM_Delivery} on:change={handleDeliveryOptionChange} id="SIM_Delivery" class="form-control requiredField">
		<option value="">Please Select</option>
		<option value="pickup">Local pickup: [click to view locations]</option>
		<option value="mail-us">USA Mail (3 - 7 business days)</option>
		<option value="mail-il">Israel Mail (3 - 7 business days)</option>
		<option value="e-sim" disabled={isKosher}>E-SIM by email {#if isKosher} (not available for kosher phones) {/if}</option>
		<option value="deliver-jerusalem">Same day delivery (up to 24 hours) to hotel or address in Jerusalem only: additional 30 Shekels</option>
		<option value="rabbi-shoub">I will get it from Rabbi Shoub at Lev Aharon</option>
	</select>
	<div class="card pl-4">
	{#if $form_order.SIM_Delivery=="mail-us" || $form_order.SIM_Delivery=="mail-il"}
		 <div id="mailingAddressWrap" transition:slide>
                <div class="form-group">
                  <label class="ff-dunbar title-2 text-brand" for="Mailing_Address">Mailing Address *</label>
                  <textarea bind:value={$form_order.Mailing_Address} id="Mailing_Address" autocomplete="shipping street-address" class="form-control" rows="5" placeholder="Full Mailing Address"></textarea>
                </div>
			  </div>
	{:else if $form_order.SIM_Delivery=="deliver-jerusalem"}
		<div id="hotelAddress" transition:slide>
                <div class="form-group">
                  <label class="ff-dunbar title-2 text-brand" for="Hotel_Address_or_Name">Address or Hotel Name * (please provide as much info as possible)</label>
                  <textarea bind:value={$form_order.Hotel_Address_or_Name} id="Hotel_Address_or_Name" class="form-control" rows="5" placeholder="Address or Hotel Name"></textarea>
                </div>
			  </div>
	{:else if $form_order.SIM_Delivery=="pickup"}
		<div id="localPickup" transition:slide>
		<label class="ff-dunbar title-2 text-brand" for="pickupLocation">Choose a pickup location *</label><br>
			{#each Object.keys(pickup_locations_list) as group}
				<b>{group}</b><br>
				{#each pickup_locations_list[group] as location (location.id)}
					<label><input type="radio" bind:group={$form_order.SIM_Pickup_Location} value={location.name}/> {location.name}</label><br>
				{/each}
			{/each}

		</div>
	{/if}
	</div>


<br /><label class="ff-dunbar title-2 text-brand" for="SIM_Card_Needed_Count">How many SIM cards would you like to purchase? *</label>
	<select bind:value={$form_order.SIM_Card_Needed_Count} name="SIM_Card_Needed_Count" id="SIM_Card_Needed_Count" class="form-control requiredField">
		<option value="">Please Select</option>
		{#if isESIM}
		<option value="1">One eSIM</option>
		<option value="2">Two eSIMS</option>
		<option value="3">Three eSIMS</option>
		{:else}
		<option value="1">One non-Kosher SIM</option>
		<option value="2">Two non-Kosher SIMS</option>
		<option value="3">Three non-Kosher SIMS</option>
		<option value="1-kosher">One Kosher SIM</option>
		<option value="2-kosher">Two Kosher SIMS</option>
		<option value="1-sim&1-kosher">One non-Kosher &amp; One Kosher SIM</option>
		{/if}
		</select>

	{#if isKosher}
	<br /><p transition:slide class="help-block alert alert-warning"> <Fa fw icon={faExclamationCircle}/> A Kosher SIM Card ONLY works in a "Kosher" Israeli Phone. It will NOT work in any basic phone. The phone must be programmed to work with a Kosher SIM. Buying a basic phone on Amazon will NOT work with a Kosher SIM.</p>
	{/if}

	{#if price}
		 <span class="help-block text-muted">Total cost in Shekels: &#8362;{price}</span><br />
	{/if}


<br />
	<label class="ff-dunbar title-2 text-brand" for="Need_SIM_Date">I must receive the sim card(s) no later than: *</label><br>
	<Datepicker format={"#{l}, #{F} #{j}, #{Y}"} start={new Date()} end={new Date(new Date().getTime()+1000*60*60*24*90)} bind:selected bind:dateChosen bind:formattedSelected>
		<button class='btn btn-light btn-outline-dark'>
		{#if dateChosen} Chosen: {formattedSelected} {:else} Pick a date {/if}<br>
		</button>
	</Datepicker>
	<br>
<!-- other options, non-svelte: tail.datetime, flatpickr(has svelte version) but all around same size and none seem so popular to be bug-free. Some let you keep the calendar open, though.-->



	<br /><label class="ff-dunbar title-2 text-brand" for="Customer_Name">First and last name of customer: *</label>
		<input type="text" bind:value={$form_order.Customer_Name} name="Customer_Name" autocomplete="name" id="Customer_Name" class="form-control requiredField" placeholder="First and last name of customer" />

	
	<br /><label class="ff-dunbar title-2 text-brand mb-0" for="Contact_Number">Contact phone number *</label>
		<br /><small>(In case we have questions before processing your order)</small>
		<input type="text" bind:value={$form_order.Contact_Number} name="Contact_Number" id="Contact_Number" autocomplete="tel" class="form-control requiredField" placeholder="Contact phone number" />

	
	<br /><label class="ff-dunbar title-2 text-brand" for="email">Email address *</label>
	<input type="text" bind:value={$form_order.email} name="email" id="email" class="form-control requiredField" placeholder="Email address" on:blur={checkEmailAddress} />
	{#if emailSuggestion}
		<div class="alert alert-danger" align="right"><i>Did you mean <a name="fixEmail" on:click={setEmail}>{emailSuggestion.address}@<b>{emailSuggestion.domain}</b></a>?</i></div>
	{/if}


		<!--<br /><label class="ff-dunbar title-2 text-brand" for="referredBy">Referred by</label>
		<select name="referred_by" bind:value={$form_order.referred_by} id="referredBy" class="form-control">
			<option value=""></option>
			{#each resellers as name}
				 <option>{name}</option>
			{/each}
			</select>-->


		<br /><label class="ff-dunbar title-2 text-brand" for="comments">Comments</label>
		<textarea bind:value={$form_order.comments} name="comments" id="comments" class="form-control" rows="4" placeholder="Comments"></textarea>


{#if errors && errors.length}
	<br />
	<div class="alert alert-danger">
	{#each errors as error}
		<div transition:slide>{error}</div>
	{/each}
	</div>
{/if}

<br />
		<div class="form-group clearfix">
		<a href="index.html" class="btn btn-success" style="float:left"><Fa fw icon={faHome}/> Home</a>
		<button type="submit" on:click|preventDefault={submitPage1} disabled={loading} class="btn btn-success formNavBtn nextBtn" style="float:right">
			{#if loading} <Spinner /> {/if}
			Continue <Fa fw icon={faAngleDoubleRight}/></button>
		</div>
</div>










{:else if step==2}
<div transition:slide class="clearfix">
<div class="alert alert-warning" id="step2_message">
<Fa fw icon={faExclamationCircle}/> IMPORTANT MESSAGE
<ul class="ml-4">
<li>It is your obligation to make sure that your phone is unlocked and compatible.</li>
<li>Refunds will not be given (for activated SIM cards) due to the fact that your phone is not unlocked.</li>
<li><b>UPDATE</b>: Verizon 4G phones are automatically unlocked only AFTER 60 DAYS of PURCHASE.</li>
<li><b>ATT, Sprint and T-Mobile phones are LOCKED</b> and you must get them unlocked. This is not always an easy task, so please be 100% sure your phone will be unlocked before ordering.</li>
<li>Please contact us via WhatsApp a <a href="https://wa.me/972547806284" target="_blank">+972-54-780-6284</a> or email at <a href="mailto:info@freedomhot.com">info@freedomhot.com</a> if you are not sure about your device.</li>
</ul>
</div>


Please select from the options below:<br/>
<label for="radio_verizon">
<input type="radio" id="radio_verizon" bind:group={$form_order.unlock_warning} value="verizon, and unlocked" />
&nbsp;My device is from Verizon and is therefore automatically unlocked (after 60 days).</label><br />

<label for="radio_non_verizon">
<input type="radio" id="radio_non_verizon" bind:group={$form_order.unlock_warning} value="non-verizon, but unlocked" />
&nbsp;My device is not from Verizon, but I am sure it is or will be unlocked. I will not receive a refund if my device is locked.</label><br />
<br /><br />

{#if errors && errors.length}
	<br />
	<div class="alert alert-danger">
	{#each errors as error}
		<div transition:slide>{error}</div>
	{/each}
	</div>
{/if}

		<div class="form-group clearfix">
		<button type="button" on:click={(s)=>{step=1}} class="btn btn-success" style="float:left"><Fa fw icon={faAngleDoubleLeft}/> Previous step</button>
		<button type="submit" on:click|preventDefault={submitPage2} disabled={loading} class="btn btn-success formNavBtn nextBtn" style="float:right">
			{#if loading} <Spinner /> {/if}
			Continue <Fa fw icon={faAngleDoubleRight}/>
			</button>
		</div>

</div>



{:else if step==3}
<div transition:slide class="clearfix">
<div class="alert alert-warning" id="step3">
You are only paying for each SIM card ordered.<br />
You are not paying now for any monthly plan.<br />
Once you receive your SIM, or anytime after, you can return to the website to activate a plan.
</div>

<hr />
<div class="p-3 mb-2 bg-info text-white text-center">Checkout</div>
<br />
<span class="center">Please take a moment to review your order.</span><br /><br />

<table class="container">
<tr><th>Item Description</th><th>Quantity</th><th>Total</th></tr>
<tr><td>SIM cards (₪{simPrice})</td>	<td>{$form_order.SIM_Card_Needed_Count[0]}</td><td>₪{($form_order.SIM_Card_Needed_Count[0]*simPrice).toFixed(2)}</td></tr>

{#if $form_order.SIM_Delivery=='deliver-jerusalem'}<!-- we have a deliver fee, so we need a final total-->
	<tr><td>Delivery (₪30)</td>	<td>1</td>	<td>₪30.00</td></tr>
	<tr><td></td><td>GRAND TOTAL:</td><th>₪{price.toFixed(2)}</th></tr>

	{/if}

</table>
<hr />

<br>
<!--small>Order id: {order_id}</small><br-->
<!-- http://tranzila:express2017!secret@doctren.interspace.net/?type=1#go_menu_content_124 
use a request ID and ... when should we have saved? 
I think kaufman saves and then shows the payment form. Then uses the request ID on a redirect to mark that it was paid. But where do we set redirect dynamically?
 -->

<!--iframe id="creditCardIframe" title="Pay by credit card" frameborder="0" style="width:100%;height:450px" 
	src="https://direct.tranzila.com/freedomhot/iframenew.php?sum={price}&currency=1&cred_type=1&tranmode=AK&buttonLabel=Complete%20Order&trButtonColor=28a745&trBgColor=e9f9bb&name={$form_order.Customer_Name}&email={$form_order.email}&order_ID={order_id}">
	</iframe-->

<CreditCardForm
	bind:credit_card_number={credit_card.credit_card_number} bind:valid={credit_card_valid}
	bind:expiry_month={credit_card.expiry_month} bind:expiry_year={credit_card.expiry_year}
	bind:ask_security_code={ask_security_code} bind:security_code={credit_card.security_code}
	/>

<!--
requestType=activation
contact=$myName
recurTransaction = '&recur_transaction=4_approved'
-->

<br><br>
{#if errors && errors.length}
	<br />
	<div class="alert alert-danger">
	{#each errors as error}
		<div transition:slide>{error}</div>
	{/each}
	</div>
{/if}

		<div class="form-group clearfix">
		<button type="button" on:click={s=>step=2} disabled={restrictToPayment} class="btn btn-success" style="float:left"><Fa fw icon={faAngleDoubleLeft}/> Previous step</button>
		<button type="submit" on:click|preventDefault={submitPayment} disabled={loading} class="btn btn-success" style="float:right">
			{#if loading} <Spinner /> {/if}
			<Fa fw icon={faShoppingCart}/> Finish Order
			</button>
		</div>

</div>


{:else if step==4}
<div transition:slide class="clearfix">
	<div class="alert alert-success">
	Success! Thank you for your order. We will contact you with updates.
	</div>
</div>
{/if}


</main>